import axios from 'axios';
import { API } from '@/utils/api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPush(employeeId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return { supported: false };
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    return { supported: true, permitted: false };
  }

  const registration = await navigator.serviceWorker.ready;

  // Get VAPID public key from backend
  const { data } = await axios.get(`${API}/push/vapid-public-key`);
  const applicationServerKey = urlBase64ToUint8Array(data.public_key);

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey,
  });

  // Send subscription to backend
  await axios.post(`${API}/push/subscribe`, {
    employee_id: employeeId,
    subscription: subscription.toJSON(),
  });

  return { supported: true, permitted: true, subscribed: true };
}

export async function unsubscribeFromPush(employeeId) {
  if (!('serviceWorker' in navigator)) return;

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    await subscription.unsubscribe();
  }

  await axios.delete(`${API}/push/unsubscribe/${employeeId}`);
}

export async function getPushStatus() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return 'unsupported';
  }

  const permission = Notification.permission;
  if (permission === 'denied') return 'denied';
  if (permission === 'default') return 'prompt';

  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.getSubscription();
  return subscription ? 'subscribed' : 'prompt';
}
